import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { clinicInfo } from '../data/mockData';

const StickyContactBar = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${clinicInfo.whatsapp.replace(/[^0-9]/g, '')}?text=Hi, I would like to book an appointment`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${clinicInfo.phone}`;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 md:hidden">
      <div className="flex gap-2 p-3">
        <Button 
          onClick={handleWhatsApp}
          className="flex-1 bg-primary hover:bg-[hsl(var(--facebook-blue-hover))] text-white font-medium py-6 transition-all duration-300"
        >
          <MessageCircle className="w-5 h-5 mr-2" />
          WhatsApp
        </Button>
        <Button 
          onClick={handleCall}
          className="flex-1 bg-primary hover:bg-[hsl(var(--facebook-blue-hover))] text-white font-medium py-6 transition-all duration-300"
        >
          <Phone className="w-5 h-5 mr-2" />
          Call Now
        </Button>
      </div>
    </div>
  );
};

export default StickyContactBar;
